import i18n from 'lib/translation'

export default i18n
